export default __webpack_public_path__ + "static/timegrid-more-link-open-13eaabdfc864542b21092e04df28e68c.png";